/*
 * Quantity stepper on the product page (sections/main-product.liquid).
 *
 * Deliberately uses data-qty-* attributes: assets/cart.js already handles
 * data-cart-qty for the cart drawer, and the two must not overlap. The input is
 * a plain <input type="number" name="quantity">, so it still works without this
 * script; this only adds the +/- buttons and keeps the value within min/max.
 */
(function () {
  'use strict';

  function clamp(input, value) {
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 99;
    if (isNaN(value)) value = min;
    value = Math.min(max, Math.max(min, value));
    input.value = value;

    // Grey out the buttons at either end of the range.
    var wrap = input.closest('[data-qty]');
    if (wrap) {
      var minus = wrap.querySelector('[data-qty-step="-1"]');
      var plus = wrap.querySelector('[data-qty-step="1"]');
      if (minus) minus.disabled = value <= min;
      if (plus) plus.disabled = value >= max;
    }
    return value;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-qty-step]');
    if (!button || button.disabled) return;
    var wrap = button.closest('[data-qty]');
    var input = wrap && wrap.querySelector('[data-qty-input]');
    if (!input) return;
    clamp(input, (parseInt(input.value, 10) || 1) + parseInt(button.getAttribute('data-qty-step'), 10));
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches && event.target.matches('[data-qty-input]')) {
      clamp(event.target, parseInt(event.target.value, 10));
    }
  });

  // Capture phase, so a typed-in "0" or "500" is corrected *before* cart.js reads the form.
  document.addEventListener('submit', function (event) {
    var input = event.target.querySelector && event.target.querySelector('[data-qty-input]');
    if (input) clamp(input, parseInt(input.value, 10));
  }, true);

  var first = document.querySelector('[data-qty-input]');
  if (first) clamp(first, parseInt(first.value, 10));
})();
